import React from 'react';

import { BrowserRouter, Switch, Route } from 'react-router-dom';
import { Display } from './pages/Display';

export default function Routes() {
  return (
    <BrowserRouter>
      <Switch>
        <Route exact path="/" component={Display} />
      </Switch>
    </BrowserRouter>
  );
}
